import { render, staticRenderFns } from "./AccountSecurity.vue?vue&type=template&id=65df3964&scoped=true"
import script from "./AccountSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSecurity.vue?vue&type=script&lang=js"
import style0 from "./AccountSecurity.vue?vue&type=style&index=0&id=65df3964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65df3964",
  null
  
)

export default component.exports